
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Container, Row, Col } from "react-bootstrap";
import "./harvestingDonePopOver.css";
import { Box, Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material';



export const HavestingDonePopOver = (props) => {


  const confirm = () => {
    props.harvestingDone();
    props.handleLogModalClose();
  }


  return (
    <>
      <Container maxWidth="xl">
        <Typography variant='h5' gutterBottom>Confirm Harvesting Completion</Typography>
        <Typography gutterBottom> Do you want to complete Harversting ?</Typography>
        <Stack direction="row">
          <Typography variant="subtitle2" gutterBottom>Harversting Weight : </Typography>
          <Typography sx={{ display: "inline", ml: 1 }} variant="body2" gutterBottom>
          {props.harvestingWeight}
          </Typography>
        </Stack>
        <Stack direction="row">
          <Typography variant="subtitle2" gutterBottom>Scheduled Weight : </Typography>
          <Typography sx={{ display: "inline",  ml: 1 }} variant="body2" gutterBottom>
          {props.scheduledWeight}
          </Typography>
        </Stack>
        {/* <Typography>Scheduled Weight : {props.scheduledWeight}</Typography> */}
        <Box display='flex' alignItems="center" justifyContent="center" mt={1} style={{ float: "right" }}>
          <Button onClick={confirm}>Yes</Button>
          <Button onClick={props.handleLogModalClose}>No</Button>
        </Box>
        {/* <Row>

          <Col xs={12} md={8}>
            <div style={{ margin: "10px" }}>
              Do you want to complete Harversting ?
              <br />
              Harversting Weight : {props.harvestingWeight}
              <br />
              Scheduled Weight : {props.scheduledWeight}
            </div>
          </Col>
          <div className="btn_container_unloading_popover">
            <input
              className="asn-cancel"
              value="No"
              onClick={props.onClose}
              type="submit"
            />
            <input
              className="asn-submit"
              value="Yes"
              onClick={confirm}
              type="submit"
            />
          </div>
        </Row> */}
      </Container>
    </>

  );
};
